/**
 * @auth 赖传峰
 * @date 2023/4/18
 */
import { webClientId } from '@/config'

export const getUserIdFromCredentials = (): string | undefined => {
  if (!localStorage) return // https://pikcloud.sentry.io/issues/4057520231
  const key = Object.keys(localStorage).find(el => el.startsWith(`credentials_${webClientId}`))
  if (!key) {
    console.log('user id key empty')
    return
  }
  const stringifyUserInfo = localStorage.getItem(key)
  if (!stringifyUserInfo) {
    console.log('user id value empty')
    return
  }
  try {
    return JSON.parse(stringifyUserInfo).sub
  } catch (err) {
    console.error(err)
  }
}
